// 接口域名
export var BASE_URL_MAP = {
  local: 'https://api.cloud.wozp.cn',
  dev: 'https://api.cloud.wozp.cn',
  test: 'https://api.cloud.wozp.cn',
  pre: 'https://api-pre.cloud.wozp.cn',
  pro: 'https://api.cloud.wozhipei.com'
};
export var DEFAULT_BASE_URL = 'https://api.cloud.wozp.cn';

// 业务
export var BUSINESS_NAME = /*#__PURE__*/function (BUSINESS_NAME) {
  BUSINESS_NAME["EXAM"] = "exam";
  return BUSINESS_NAME;
}({});